<template>
  <span>
    <svg
        id="Layer_1"
        :height="size"
        :width="size"
        class="x-spin"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 62 62" >
      <path
          :style="style"
          d="M30.5 1h1c-.4.7-.8 1.5-1.1 2.2-.2.4-.3 1.2-.2 1.3.4.2 1.1.4 1.5.2.8-.2 1.5-.7 2.2-1.1 2-1.3 4-1.5 6.4-.8-.3.4-.4.5-.5.7-.4.8-.8 1.5-1.3 2.2.9.1 1.8.4 2.7.3 2.6-.3 5.2-1.1 7.5 1.2-.6.3-1.2.4-1.6.8-.5.4-.8 1-1.1 1.5.5.3.9.7 1.4.9.7.2 1.5.2 2.2.3 2.3.2 4.3 1 5.4 2.9-1.1.6-2.1 1.1-3.1 1.7.9.7 1.7 1.5 2.6 2 2.2 1 4.1 2.2 4.7 4.8H58c-.8.1-1.5.2-2.3.3.3.7.5 1.5 1.1 2 1.9 1.7 3.6 3.6 4.2 6.2v1c-.7-.4-1.5-.8-2.2-1.1-.4-.2-1.2-.3-1.3-.2-.2.4-.4 1.1-.2 1.5.2.8.7 1.5 1.1 2.2 1.3 2 1.5 4 .8 6.4-.4-.3-.5-.4-.7-.5-.7-.5-1.5-.9-2.2-1.3-.1.9-.4 1.8-.3 2.7.3 2.6 1.1 5.2-1.2 7.5-.3-.6-.4-1.2-.8-1.6-.4-.4-.9-.7-1.4-1.1-.3.5-.7.9-.9 1.4-.2.7-.2 1.5-.3 2.2-.2 2.3-1 4.3-2.9 5.4-.6-1.1-1.1-2.1-1.7-3.1-.7.9-1.5 1.7-2 2.6-1 2.2-2.2 4.1-4.8 4.7v-1.2c-.1-.8-.2-1.5-.3-2.3-.7.3-1.5.5-2 1.1-1.7 1.9-3.6 3.6-6.2 4.2h-1c.4-.7.8-1.5 1.1-2.2.2-.4.3-1.2.2-1.3-.4-.2-1.1-.4-1.5-.2-.8.2-1.5.7-2.2 1.1-2 1.3-4 1.5-6.4.8.3-.4.4-.5.5-.7.5-.7.9-1.5 1.3-2.2-.9-.1-1.8-.4-2.7-.3-2.6.3-5.2 1.1-7.5-1.2.6-.3 1.2-.4 1.6-.8.4-.4.7-.9 1.1-1.4-.5-.3-.9-.7-1.4-.9-.7-.2-1.5-.2-2.2-.3-2.3-.2-4.3-1-5.4-2.9 1.1-.6 2.1-1.1 3.1-1.7-.9-.7-1.7-1.5-2.6-2-2.2-1-4.1-2.2-4.7-4.8H4c.8-.1 1.5-.2 2.3-.3-.3-.7-.5-1.5-1.1-2-2-1.8-3.6-3.7-4.2-6.3v-1c.7.4 1.5.8 2.2 1.1.4.2 1.2.3 1.3.2.2-.4.4-1.1.2-1.5-.2-.8-.7-1.5-1.1-2.2-1.3-2-1.5-4-.8-6.4.4.3.5.4.7.5.8.4 1.5.8 2.2 1.3.1-.9.4-1.8.3-2.7-.3-2.6-1.1-5.2 1.2-7.5.3.6.4 1.2.8 1.6.4.5 1 .8 1.5 1.1.3-.5.7-.9.9-1.4.2-.7.2-1.5.3-2.2.2-2.3 1-4.3 2.9-5.4.6 1.1 1.1 2.1 1.7 3.1.7-.9 1.5-1.7 2-2.6 1-2.2 2.2-4.1 4.8-4.7V4c.1.8.2 1.5.3 2.3.7-.3 1.5-.5 2-1.1 1.6-2 3.5-3.6 6.1-4.2z"/>
      <circle :style="style" cx="31" cy="31" r="6"/>
      <circle :style="style" cx="16.8" cy="31" r="2"/>
      <circle :style="style" cx="45.2" cy="31" r="2"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'loading-indicator',
  props: {
    size: {
      type: Number,
      default: 64,
    },
    color: {
      type: String,
      default: '#F96302',
    },
  },
  computed: {
    style () {
      return {
        fill: 'none',
        stroke: this.color,
        'stroke-miterlimit': 10,
      };
    },
  },
};
</script>
